<template>
	<popup-dialog :full-width="true" :popup-active="popupStatus">
		<i @click="popupClose" class="fas fa-times popup-close"></i>
		<div class="popup popup--settings bg--white">
			<div class="popup-sidebar scrollbar-custom">
				<div class="popup-link">
					<div
						class="popup-link__section"
					>
						<div
							v-for="(link, $indexLink) in mediaSections"
							:key="`link-${$indexLink}`"
							:class="{
								active: link.VALUE === mediaOpened,
								disabled: isRestricted(link.VALUE)
							}"
							@click="mediaChoose(link.VALUE)"
							class="popup-link__item"
						>{{ link.TITLE }}</div>
					</div>
				</div>
			</div>
			<div class="popup__content scrollbar-custom">
				<media-assets
					v-if="isAssetsOpened"
					@chosen-media="getChosenMedia"
				></media-assets>
				<media-templates
					v-if="isTemplatesOpened"
					@chosen-media="getChosenMedia"
				></media-templates>
			</div>
		</div>
	</popup-dialog>
</template>

<script>
import PopupDialog from '@/components/ui/popup/PopupDialog';
import MediaAssets from '@/components/editor-options/settings/popup/content/media/MediaAssets';
import MediaTemplates from '@/components/editor-options/settings/popup/content/media/MediaTemplates';
import {computed, ref, inject} from 'vue';
import {POPUP_SETTINGS} from '@/models/POPUP_SETTINGS';
import {useStore} from 'vuex';
export default {
	components: {
		PopupDialog,
		MediaAssets,
		MediaTemplates,
	},
	emits: ["chosenMedia", "popupClose"],
	props:{
		popupStatus: {
			type: Boolean,
			default: false
		},
	},
	setup(props, {emit}) {
		const store = useStore();
		const isMediaContentActive = computed(() => store.getters['mediaContent/isMediaContentActive']);
		function popupClose(){
			emit('popupClose');
		}
		
		// CLIENT RESTRICTIONS
		const clientRestrictions = computed(() => store.getters["clients/getRestrictions"]);
		const hasAssetManagement = computed(() => clientRestrictions.value.hasAssetManagement.value);
		const hasMediaTemplates = computed(() => clientRestrictions.value.hasMediaTemplates.value);
		function isRestricted(link){
			if(!clientRestrictions.value) return false;
			for(const restriction of Object.values(clientRestrictions.value)){
				if(restriction.option === link && !restriction.value) {
					return true;
				}
			}
		}
		
		const mediaAssetsSection = POPUP_SETTINGS.CONTENT.SECTIONS[1].MANAGE_ASSETS;
		const mediaTemplatesSection = POPUP_SETTINGS.CONTENT.SECTIONS[1].MEDIA_TEMPLATES;
		const mediaSections = [mediaAssetsSection, mediaTemplatesSection];
		const mediaOpened = ref(hasAssetManagement.value ? mediaAssetsSection.VALUE : mediaTemplatesSection.VALUE);
		const isAssetsOpened = computed(() => mediaOpened.value === mediaAssetsSection.VALUE);
		const isTemplatesOpened = computed(() => mediaOpened.value === mediaTemplatesSection.VALUE);
		function mediaChoose(value){
			if(isRestricted(value)) return;
			mediaOpened.value = value;
		}
		function getChosenMedia(mediaData){
      const {url, name, type} = mediaData;
			emit('chosenMedia', url);
		}
		
		return {
			isMediaContentActive,
			mediaSections,
			mediaOpened,
			isAssetsOpened,
			isTemplatesOpened,
			mediaChoose,
			getChosenMedia,
			popupClose,
			isRestricted
		}
	}
}
</script>

<style lang="scss">

</style>

